module.exports = __webpack_public_path__ + "static/media/22_Sample_house.737d1979.jpg";